import type {
  Shot,
  LaunchMeasurementMessage,
  FinalMeasurementMessage,
} from "../types/shot.types";

export function buildFlyingShot(
  payload: LaunchMeasurementMessage["Payload"],
  hasConsent: boolean,
  radarId: string,
  sessionId?: string
): Shot {
  const eventTime = payload.Time || payload["#Header"]?.EventTime || undefined;
  const timestamp = eventTime ? new Date(eventTime).getTime() : Date.now();

  return {
    id: payload.Id,
    sessionId: sessionId ?? "",
    radarId,
    timestamp,
    localCreatedAt: Date.now(),
    ballSpeed: payload.BallSpeed,
    launchAngle: payload.LaunchAngle,
    launchDirection: payload.LaunchDirection,
    spinRate: 0,
    carryDistance: 0,
    maxHeight: 0,
    curve: 0,
    carrySide: 0,
    spinAxis: 0,
    landingAngle: undefined,
    landingSpeed: undefined,
    actualCarry: undefined,
    status: "flying",
    hasConsent,
    showOnTV: true,
    teePosition: payload.TeePosition,
  };
}

export function buildLandedShotFromUpdate(
  existingShot: Shot,
  payload: FinalMeasurementMessage["Payload"]
): Shot {
  return {
    ...existingShot,
    ballSpeed: payload.BallSpeed,
    launchAngle: payload.LaunchAngle,
    launchDirection: payload.LaunchDirection,
    spinRate: payload.SpinRate,
    carryDistance: payload.Carry,
    maxHeight: payload.MaxHeight,
    curve: payload.ActualCurve,
    carrySide: payload.ActualSide,
    spinAxis: payload.SpinAxis,
    landingAngle: payload.LandingAngle ?? undefined,
    actualLandingAngle: payload.ActualLandingAngle ?? undefined,
    landingSpeed: payload.ActualLandingSpeed ?? undefined,
    actualCarry: payload.ActualCarry ?? undefined,
    total: payload.Total ?? undefined,
    fromPin: payload.BounceAndRollDistanceToPin ?? undefined,
    status: "landed",
    teePosition: payload.TeePosition,
    landingPosition: payload.LandingPosition,
    actualLandingPosition: payload.ActualLandingPosition,
    finalPosition: payload.BounceAndRollModelEndPositionSCS,
  };
}

export function buildLandedShotFromScratch(
  payload: FinalMeasurementMessage["Payload"],
  hasConsent: boolean,
  radarId: string
): Shot {
  return {
    id: payload.Id,
    sessionId: "",
    radarId,
    timestamp: Date.now(),
    localCreatedAt: Date.now(),
    ballSpeed: payload.BallSpeed,
    launchAngle: payload.LaunchAngle,
    launchDirection: payload.LaunchDirection,
    spinRate: payload.SpinRate,
    carryDistance: payload.Carry,
    maxHeight: payload.MaxHeight,
    curve: payload.ActualCurve,
    carrySide: payload.ActualSide,
    spinAxis: payload.SpinAxis,
    landingAngle: payload.LandingAngle ?? undefined,
    landingSpeed: payload.ActualLandingSpeed ?? undefined,
    actualCarry: payload.ActualCarry ?? undefined,
    total: payload.Total ?? undefined,
    fromPin: payload.BounceAndRollDistanceToPin ?? undefined,
    status: "landed",
    hasConsent,
    showOnTV: true,
    teePosition: payload.TeePosition,
    landingPosition: payload.LandingPosition,
    actualLandingPosition: payload.ActualLandingPosition,
    finalPosition: payload.BounceAndRollModelEndPositionSCS,
  };
}
